import React from "react";
import Navbar from "./home/Navbar";
import Footer from "./home/footer";
import ScrollToTop from "./ScrollToTop";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main><Outlet /></main>
      <Footer />
    </>
  );
};

export default Layout;
